import styled from 'styled-components';
import Spinner from 'global/Loading/SecondarySpinner';

// copy from web legacy in build.css
const UploadProfilePictureWrapper = styled.div`
  #compose-modal-cropping:empty {
    z-index: -1;
    opacity: 0;
  }

  #compose-modal-cropping {
    overflow-y: auto;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1100;
    display: flex;
    opacity: 1;
    align-items: center;
    justify-content: center;
    padding: 50px 20%;
  }

  .modal-general-in {
    background: #fff;
    border-radius: 2px;
    position: relative;
    overflow: hidden;
  }

  .modal-title-close {
    width: 30px;
    height: 43px;
    position: absolute;
    right: 10px;
    top: 16px;
    /* background: url(/icon/close.png) right center / 20px auto no-repeat; */
    cursor: pointer;
  }

  .modal-title {
    padding: 10px 15px;
    font-weight: bold;
    font-size: 18px;
    cursor: pointer;
    border-bottom: solid 1px #dadada;
  }

  .circle-cropping > div > div > div > div {
    border-radius: 50%;
  }

  .modal-button {
    width: 50%;
    display: block;
    float: left;
    border: 0;
    padding: 10px;
    background: #fff;
    cursor: pointer;
  }

  .modal-button:first-of-type {
    border-radius: 0 0 0 2px;
  }

  .modal-button:last-of-type {
    border-radius: 0 0 2px;
    border-left: solid 1px #dadada;
  }
  .modal-save {
    background: #00ab6b;
    border-top: solid 1px #00ab6b;
    color: #fff;
  }

  .modal-cancel {
    border-top: solid 1px #dadada;
  }

  .boarding-avatar {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    overflow: hidden;
    margin: 0 auto 30px auto;
    background: #ddd no-repeat center center / 51px auto
      url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAYAAAA6oTAqAAAACXBIWXMAAAsSAAALEgHS3X78AAADF0lEQVRo3u1awXHiQBBsXP6jDKwMTAZWBlYGwJupOjKwHIH1mL9xBiKCkzMQGYgIDiLwfXqv5lQCW9IiTj5tFaUSsKvtmemZnoXJx8cHvsu4wTcaI5gRTA/jtusCIhIAmPnYjKrmXeZPumQzEUkB/PBo3D2AtapmvYIRkQWA1wtEyxFAqKqHPsNswetWVWMP4RoCKABMuXbaZwJwPMk88aUkGAAIe8tmJP2Ut6XHECsqhurFM7OaDfgYjidB6wRASycNLBIAuAdwVNXAFxIRiQD85O17g6mZqqYuAeTcXNuw8O0ZAHhoMO9BRMLJarWy1tg23GCpqhufaEQkaTgldlHyFxhVnQxNwtjQvL3QA0JaLCK/Zsx6B16zJlXerOf4UV5Em9Wk7BTAvObje8OFuYjsASSfhWmN0ngRkWXdvBuPQGJafW5kyRbAM4Alr88Advz8DsCriOQ0Qt2asxOS6ZXe8u+ZivWO9E56Ql8l3MiGXnoAkItIVPN9K5OWVAZPRk4lvluAyADZA4hVtfiCdIlEZA3ghSGYn6lzR2bZwoDx25wxPDbmgbPPgFRApbQ4ANzXpGW31pRgbb+T+ebMmrEPeqSxbCeRt7x9slxgxnszgJwefKszmg8wbvEuXeKCnrWthQO0oPe2fC35nr/UTK44S6VdLKKqBxHJmAnjKrHpvU+VRhfPRI70TXhyTixW6tFVTmd89TNlpb4M96ip4t1g0GDqKvo1wISe8MyMl/K+wbgH3vmwqpEuu949Q+u52pB0DLHASvxrhZmrL/O2GYhjw5p17FKzfIBx3slOSfkvKO5Ht14bSeQFDB8cm/4kb+IhqmanuHeq2ilcO2czcmdpqncuIsk5L4lIJCI55b8jfdR1L16aM1XdiMjBxP4TgDU3XJgjpJCbtpLlva3ivtgZgKpmDLGEgnFKLjyemPKlM4CrgDEd5IJNlj2dCY3+KgDkbX+D6Q1MBVTatTUYrDYbwZwD06bo/QMjsJyxKfGXiAzVMfsbNkVvA4+wI4D1n1+bWSOCgYIpVbWcjP9qGsGMYP5fML8Bx5lBVIkOEH8AAAAASUVORK5CYII=');
    display: block;
    margin: auto;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 30px;
    cursor: pointer;
  }

  .spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    overflow: hidden;
    margin: 0 auto 30px auto;
    background: #ddd;
    margin: auto;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 30px;
    cursor: pointer;
  }

  .boarding-avatar img {
    width: 100%;
  }

  .boarding-avatar .PrimarySpinner {
    min-height: 0;
  }

  .boarding-avatar .loading .generalspinner,
  .boarding-avatar.loading .PrimarySpinner {
    height: 120px;
  }

  .popavatar {
    width: 100%;
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-fill-mode: forwards;
    animation-fill-mode: forwards;
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    -webkit-animation-name: popimg;
    animation-name: popimg;
  }

  .circle-cropping > div > div {
    display: inherit !important;
  }
`;

const CustomSpinner = styled(Spinner)`
  position: absolute;
  div {
    color: white;
    height: 30px;
    width: 30px;
    border-bottom-color: white;
    border-left-color: white;
    border-top-color: white;
  }
`;

export { UploadProfilePictureWrapper, CustomSpinner };
